module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/01_Cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/02_Titlepage"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/03_Copyright"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/04_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/05_Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/07_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_vm._v("Chapter 1: The Early Camps, 1939-1940")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/10_Chapter01#sec_1"
    }
  }, [_vm._v("Oflag X (Itzehoe) September-October 1939")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/10_Chapter01#sec_2"
    }
  }, [_vm._v("Oflag IVC (Colditz) June 1940-April 1945")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/10_Chapter01#sec_3"
    }
  }, [_vm._v("Oflag IXA/H (Spangenberg) October 1939-April 1942")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/11_Chapter02"
    }
  }, [_vm._v("Chapter 2: Dulag Luft: December 1939-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Stalag VIIIB (Lamsdorf): May 1940-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Stalag Luft I (Barth): June 1940-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Wehrmacht Camps, 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIIC (Laufen) July 1941-September 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XC (Lübeck) July 1941-October 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIB (Warburg) October 1941-September 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IXC (Bad Sulza) July 1941-May 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIE (Kirchhain) July 1941-May 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/14_Chapter05#sec_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) December 1941-September 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Stalag Luft III (Sagan): March 1942-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Wehrmacht Camps, 1942-1943")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/16_Chapter07#sec_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag 383 (Hohenfels) September 1942-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/16_Chapter07#sec_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XXIB (Schubin) October 1942-May 1943")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/16_Chapter07#sec_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IVB (Mühlberg) June 1943-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Stalag Luft VI (Heydekrug): June 1943-July 1944")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Stalag Luft IV (Gross Tychow): July 1944-February 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Stalag 357 (Thorn and Oerbke); Stalag XIB (Fallingbostel): July 1944-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Stalag Luft VII (Bankau): June 1944-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Last Camps: Marlag und Milag Nord February 1945-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/21_Chapter12#sec_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIA (Luckenwalde) January-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/21_Chapter12#sec_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag XIIID (Langwasser-Nürnberg) January-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/21_Chapter12#sec_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) January-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 Operation Exodus: 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Wounded: 1939-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Repatriations: 1943-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Traitors and Collaborators: 1940-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: War Crimes, 1939-1944")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: War Crimes, 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Introduction to the List of RAF Bomber Command Prisoners-of-War")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/29_Plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Gallery")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/30_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I: The List of RAF Bomber Command PoWs")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/31_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II: Numbering System and Location of German PoW Camps")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/32_Appendix_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix III: Periods of occupation of German PoW camps by RAF PoWs, 1939-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/33_Appendix_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV: RAF Bomber Command PoW losses, 1939-1945: by month")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/34_Appendix_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V: RAF Bomber Command PoW losses, 1939-1945: by aircraft type")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/35_Appendix_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VI: RAF Bomber Command PoW losses, 1939-1945: by squadron")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/36_Appendix_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VII: RAF Bomber Command PoW losses, 1939-1945: by rank")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/37_Appendix_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VIII: RAF Bomber Command PoW losses, 1939-1945: by nationality")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/38_Appendix_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IX: RAF Bomber Command PoW losses, 1939-1945: by target")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/39_Appendix_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix X: RAF escapers, 1941-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/40_Appendix_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XI: Comparative British and German Ranks")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/41_Appendix_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XII: The Nazi Propaganda Campaign against Airmen")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/42_Appendix_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIII: The Nazi Party Security Forces")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/43_Appendix_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIV: Red Cross Parcels")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/43_Plans_PoW",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plans of some PoW camps used by RAF")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/44_Notes_to_Chapters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes to Chapters")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/45_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("Guide")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "cover",
      "href": "#/xhtml/01_Cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "title",
      "href": "#/xhtml/02_Titlepage"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/03_Copyright"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "dedication",
      "href": "#/xhtml/04_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/xhtml/05_Contents"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/07_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "frontmatter",
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_vm._v("Chapter 1: The Early Camps, 1939-1940")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/10_Chapter01#sec_1"
    }
  }, [_vm._v("Oflag X (Itzehoe) September-October 1939")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/10_Chapter01#sec_2"
    }
  }, [_vm._v("Oflag IVC (Colditz) June 1940-April 1945")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/10_Chapter01#sec_3"
    }
  }, [_vm._v("Oflag IXA/H (Spangenberg) October 1939-April 1942")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/11_Chapter02"
    }
  }, [_vm._v("Chapter 2: Dulag Luft: December 1939-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Stalag VIIIB (Lamsdorf): May 1940-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Stalag Luft I (Barth): June 1940-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Wehrmacht Camps, 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIIC (Laufen) July 1941-September 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XC (Lübeck) July 1941-October 1941")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIB (Warburg) October 1941-September 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IXC (Bad Sulza) July 1941-May 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIE (Kirchhain) July 1941-May 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/14_Chapter05#sec_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) December 1941-September 1942")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Stalag Luft III (Sagan): March 1942-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Wehrmacht Camps, 1942-1943")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/16_Chapter07#sec_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag 383 (Hohenfels) September 1942-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/16_Chapter07#sec_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XXIB (Schubin) October 1942-May 1943")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/16_Chapter07#sec_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IVB (Mühlberg) June 1943-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Stalag Luft VI (Heydekrug): June 1943-July 1944")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Stalag Luft IV (Gross Tychow): July 1944-February 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Stalag 357 (Thorn and Oerbke); Stalag XIB (Fallingbostel): July 1944-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Stalag Luft VII (Bankau): June 1944-January 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The Last Camps: Marlag und Milag Nord February 1945-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/21_Chapter12#sec_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIA (Luckenwalde) January-May 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/21_Chapter12#sec_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag XIIID (Langwasser-Nürnberg) January-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/21_Chapter12#sec_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) January-April 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 Operation Exodus: 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Wounded: 1939-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Repatriations: 1943-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Traitors and Collaborators: 1940-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: War Crimes, 1939-1944")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: War Crimes, 1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Introduction to the List of RAF Bomber Command Prisoners-of-War")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/xhtml/29_Plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Gallery")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/30_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I: The List of RAF Bomber Command PoWs")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/31_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II: Numbering System and Location of German PoW Camps")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/32_Appendix_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix III: Periods of occupation of German PoW camps by RAF PoWs, 1939-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/33_Appendix_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV: RAF Bomber Command PoW losses, 1939-1945: by month")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/34_Appendix_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V: RAF Bomber Command PoW losses, 1939-1945: by aircraft type")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/35_Appendix_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VI: RAF Bomber Command PoW losses, 1939-1945: by squadron")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/36_Appendix_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VII: RAF Bomber Command PoW losses, 1939-1945: by rank")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/37_Appendix_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VIII: RAF Bomber Command PoW losses, 1939-1945: by nationality")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/38_Appendix_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IX: RAF Bomber Command PoW losses, 1939-1945: by target")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/39_Appendix_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix X: RAF escapers, 1941-1945")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/40_Appendix_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XI: Comparative British and German Ranks")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/41_Appendix_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XII: The Nazi Propaganda Campaign against Airmen")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/42_Appendix_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIII: The Nazi Party Security Forces")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/43_Appendix_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIV: Red Cross Parcels")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/43_Plans_PoW",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plans of some PoW camps used by RAF")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/44_Notes_to_Chapters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes to Chapters")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "backmatter",
      "href": "#/xhtml/45_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "page-list"
    }
  }, [_c('h2', [_vm._v("Pagebreaks of the print version")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Titlepage#pagei"
    }
  }, [_vm._v("i")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Copyright#pageii"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Copyright#pageiii"
    }
  }, [_vm._v("iii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Copyright#pageiv"
    }
  }, [_vm._v("iv")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Dedication#pagev"
    }
  }, [_vm._v("v")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Dedication#pagevi"
    }
  }, [_vm._v("vi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Contents#pagevii"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements#pageviii"
    }
  }, [_vm._v("viii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements#pageix"
    }
  }, [_vm._v("ix")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary#pagex"
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary#pagexi"
    }
  }, [_vm._v("xi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary#pagexii"
    }
  }, [_vm._v("xii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface#pagexiii"
    }
  }, [_vm._v("xiii")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface#pagexiv"
    }
  }, [_vm._v("xiv")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction#pagexv"
    }
  }, [_vm._v("xv")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction#pagexvi"
    }
  }, [_vm._v("xvi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#page12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page17"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page18"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page20"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page21"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page22"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page24"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page26"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#page27"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#page41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#page55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#page69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06#page83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#page97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08#page107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09#page115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#page122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#page131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#page142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#page155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#page169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#page180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#page197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#page211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#page224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#page231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLIII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLIV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLVIII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLIX")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLX")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXIII")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXIV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXV")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates#pagePLXVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLXVI")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("251")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("256")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("257")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("262")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("263")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("264")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("265")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("266")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("268")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("270")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("272")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("274")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("276")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("279")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("280")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("281")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("282")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("283")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("284")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("288")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("290")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("293")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("294")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("295")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("297")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("298")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("299")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("300")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("301")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("302")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("304")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("306")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("307")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("308")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("310")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("312")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("316")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("317")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("322")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("326")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("327")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("329")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("330")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("332")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("342")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("346")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("349")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("351")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("352")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("353")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("354")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("355")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("356")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("360")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("361")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("362")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("363")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("365")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("366")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("367")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("368")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("370")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("371")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("372")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("373")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("374")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("375")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("376")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("377")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("378")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("379")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("380")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("381")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("382")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("383")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("384")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("385")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("386")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("387")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("388")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("389")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("390")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("391")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("392")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("393")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("394")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("395")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("396")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("397")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("398")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("399")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("400")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("401")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("402")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("403")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("404")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("405")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("406")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("407")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("408")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("409")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("410")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("411")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("412")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("413")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("414")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("415")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("416")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("417")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("418")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("419")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("420")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("421")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("422")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("423")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("424")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("425")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("426")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("427")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("428")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("429")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page430",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("430")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("431")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("432")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("433")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("434")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("435")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("436")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("437")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("438")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("439")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("440")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page441",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("441")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I#page442",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("442")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page443",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("443")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("444")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("445")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("446")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("447")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II#page448",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("448")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Appendix_III#page449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("449")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Appendix_IV#page450",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("450")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V#page451",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("451")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V#page452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("452")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V#page453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("453")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V#page454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("454")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_VI#page455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("455")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_VI#page456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("456")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_VI#page457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("457")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Appendix_VII#page458",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("458")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix_VIII#page459",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("459")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("460")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("461")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("462")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page463",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("463")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page464",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("464")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page465",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("465")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX#page466",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("466")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix_X#page467",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("467")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix_X#page468",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("468")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix_X#page469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("469")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix_XI#page470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("470")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix_XII#page471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("471")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix_XII#page472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("472")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix_XII#page473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("473")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Appendix_XIII#page474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("474")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Appendix_XIII#page475",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("475")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Appendix_XIII#page476",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("476")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix_XIV#page477",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("477")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix_XIV#page478",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("478")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix_XIV#page479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("479")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Plans_PoW#page480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("480")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Plans_PoW#page481",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("481")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("482")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page483",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("483")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("484")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("485")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("486")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("487")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page488",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("488")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page489",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("489")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page490",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("490")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("491")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page492",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("492")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("493")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page494",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("494")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("495")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page496",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("496")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("497")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page498",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("498")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page499",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("499")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page500",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page501",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("501")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page502",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("502")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("503")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("504")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page505",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("505")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("506")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("507")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page508",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("508")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("509")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page510",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("510")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters#page511",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("511")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("512")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("513")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page514",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("514")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("515")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("516")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography#page517",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("517")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 54
// module chunks = 0